import useGetDocumentInvoiceFilterDimensions from "hooks/api/documents/documentFilterDimensions/useGetDocumentInvoiceFilterDimensions";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { ProductFilter } from "../GenericFilters/ProductFilter";
import { FilterProps } from "../filter-definition";
import useFeatureFlag from "hooks/useFeatureFlag";
import { DOCUMENTS } from "util/featureFlags";

export const InvoicesProductFilter = ({ variant }: FilterProps) => {
  const cardCodes = useSelectedCustomerCode();
  const { data, isLoading } = useGetDocumentInvoiceFilterDimensions(cardCodes);

  const productOptions = data?.products;

  const isDocumentFilterFeatureEnabled = useFeatureFlag(
    DOCUMENTS.FILTER_BUTTONS
  );

  if (!isDocumentFilterFeatureEnabled) {
    return null;
  }

  return (
    <ProductFilter
      filterKey="product"
      name="Product"
      variant={variant}
      productOptions={productOptions}
      isLoading={isLoading}
    />
  );
};
